<template>
    <div class="lead-intake-container">
        <hb-blade-header title-icon="mdi-currency-usd" title="Record a Payment" backButtonOff @close="$emit('close')">
        </hb-blade-header>
        <div class="lead-intake-top" no gutters>
            <!-- left side -->
            <div class="navigation-panel-container">
                <div class="pa-4">
                    <hb-mini-profile type="account" :title="contact.Business.name" 
                    :phone="contact.Phones[0].phone | formatPhone" :status="contact.status ? contact.status : undefined"
                     :can-text="true" :email="contact.email" :representative-name="contact.first + ' ' + contact.last"
                        :address="computedBusinessAddress" :id-verified="contact.email_verified
                            ? contact.email_verified
                            : undefined
                            " :account-space-count="calculateLength"
                        :account-space-type="contact.Leases && contact.Leases?.length === 1 ? contact?.Leases[0]?.Unit?.type : ''"
                        />
                    <v-divider class="my-5 pa-0 mt-3"></v-divider>


                    <v-expansion-panels  v-model="panel" multiple left-cols="7" right-cols="5">
                            <v-row no-gutters v-if="invoice.length" color="#101318" class="hb-font-header-2-medium mt-n1">
                                Invoice Information
                            </v-row>
                            
                        <hb-expansion-panel :left-cols="6" :right-cols="5" v-for="(line, i) in invoice" :key="i" class="my-5" v-if= "line.balance > 0" >
                             <template v-slot:title class="d-flex align-center justify-center">
                                <span>
                                    <v-row no-gutters>
                                        <hb-checkbox @click.stop v-model="pay[i]" @change="addPayment(line,i) ">{{pay[i]}}</hb-checkbox>
                                        <span class=" ma-1"> {{line.invoice_number}} </span>
                                    </v-row>
                                </span ></template>
                            <template v-slot:actions>
                                <span class="pr-6 hb-font-header-3-medium">
                                    <span class="pr-4  hb-font-header-3 ">Total Due:</span>{{ line.balance  | formatMoney
                                    }}
                                </span>
                            </template>

                            <template v-slot:content>
                                <v-container fluid>
                                    <v-row no-gutters>
                                        <v-col>
                                            <span class=" mt-4 pr-6 hb-font-caption-medium ">Invoice Total : </span>
                                        </v-col>
                                        <v-col class="pr-6 hb-font-caption-medium d-flex justify-end ">
                                            <span class="pr-4">{{ line.amount  | formatMoney }}</span>
                                        </v-col>

                                    </v-row>
                                    <v-row no-gutters v-if="line.balance != line.amount">
                                        <v-col>
                                            <span class="mt-4 pr-6 hb-font-header-3 ">Previous Payments / Credits:</span>
                                        </v-col>
                                        <v-col class="pr-6 hb-font-caption d-flex justify-end ">
                                            <span class="pr-4">-{{ line.amount - line.balance | formatMoney }}</span>
                                        </v-col>

                                    </v-row>
                                </v-container>
                                <v-divider></v-divider>
                                <v-container fluid>
                                    <v-row class="pr-6 justify-end">
                                        <span class="pr-6 hb-font-header-3 ">Balance Due:</span> <span
                                            class="pr-4 hb-font-header-3-medium d-flex justify-end">{{ line.balance | formatMoney }}</span>
                                    </v-row>
                                </v-container>
                            </template>
                        </hb-expansion-panel>
                            <v-row no-gutters color="#101318" v-if="invoice.length" class="hb-font-header-2-medium mt-n1">
                                Payment Information
                            </v-row>
                        <hb-expansion-panel v-if="invoice.length" :left-cols="6
            " :right-cols="5" expand-icon-off>
                            <template v-slot:title class="hb-font-caption ma-0 pa-0 mt-6 d-flex ">
                                <v-col>
                                    <v-row class="hb-font-caption">
                                        <hb-checkbox v-model="edit"  @change="setPayment(edit)">
                                           <template v-slot:label >
                                            <span class="disabled-label" > Reallocate or Choose a different amount</span> 
                                           </template>
                                        </hb-checkbox>
                                    </v-row>
                                
                                </v-col >
                               </template>
                            <template v-slot:actions >
                                <v-row @click.stop class="align-center  hb-font-header-3-medium d-flex justify-end">
                                    <span  @click.stop>Total Payment : &nbsp;</span>
                                     <hb-text-field  @click.stop v-if="edit" condensed box medium v-model="total_amount"
                                        v-validate="'required|max:45'" placeholder="0" class="pt-3">
                                        <template v-slot:prepend-inner>
                                            $
                                        </template> 
                                    </hb-text-field> 
                                    <span v-else> {{  total_amount | formatMoney}}</span>
                                </v-row>
                            </template>
                            <template v-slot:content>
                                <v-card elevation="0">
                                    <v-card-title class="d-flex align-center ma-0 pa-0 inv-header-cell">
                                        <v-col cols="6" class="d-flex  hb-font-body-medium align-center justify-start">
                                            <span>Invoice</span>
                                        </v-col>
                                        <v-col cols="3" class="d-flex hb-font-body-medium align-center justify-end">
                                            <span>Balance Due</span>
                                        </v-col>
                                        <v-col cols="3" class="d-flex  hb-font-body-medium align-center justify-end">
                                            <span>Amount Applied</span>
                                        </v-col>
                                    </v-card-title>
                                    <v-divider></v-divider>
                                    <v-card-text v-for="(line, index) in invoices_payments"
                                        class="pa-0 ma-0 hb-default-font-size" >
                                        <v-row class="d-flex pa-0 mx-0">
                                            <v-col cols="6" class="d-flex align-center hb-font-caption-medium justify-start">
                                                <span>{{ line.invoice_number }}</span>
                                            </v-col>

                                            <v-col cols="3" class="d-flex align-center hb-font-caption-medium justify-end ">
                                                <span>{{ line.balance  | formatMoney }}</span>
                                            </v-col>

                                            <v-col cols="3" class="d-flex align-center hb-font-caption-medium justify-end">
                                                <hb-text-field v-if="edit" condensed box medium v-model="invoices_payments[index].amount"
                                                    v-validate="'required|max:45'" placeholder="0">
                                                    <template v-slot:prepend-inner>
                                                        $
                                                    </template>
                                                </hb-text-field>
                                                <span v-else>{{ line.amount | formatMoney }}</span>
                                            </v-col>

                                        </v-row>
                                        <v-divider></v-divider>

                                    </v-card-text>
                                    <v-container  v-if=" total_amount - totalamount > 0" fluid>
                                    <v-row class="pr-6 justify-end" >
                                        <span class="pr-6  hb-font-header-3-medium ">  Over-payment - PMT</span> <span
                                            class="pr-4 hb-font-header-3-medium d-flex justify-end" v-if=" total_amount - totalamount > 0">{{total_amount - totalamount | formatMoney}}</span>
                                        <span v-else>{{ "00" | formatMoney}}</span>
                                    </v-row>
                                </v-container>
                                </v-card>
                            </template>
                        </hb-expansion-panel>
                    </v-expansion-panels>
                        <v-container class="payment-data-container hb-elevation-medium hb-border-default pa-0">
                            <v-row no-gutters>
                                <v-col cols="12" class="py-0" >
                                <v-radio-group v-model="payment_type" :mandatory="false" >
                                    <v-expansion-panels  accordion focusable class="expansion-panel">
                                      <v-expansion-panel>
                                        <v-expansion-panel-header expand-icon="">
                                            <v-radio value="bank_transfer">
                                                <template v-slot:label>
                                                    <div class="d-flex  align-center justify-space-between label-width">
                                                    <div class="d-flex align-center hb-font-body-medium">
                                                        Bank Transfer
                                                    </div>
                                                    <div><hb-icon class="mr-3" color="#101318">mdi-bank</hb-icon></div>
                                                    </div>
                                                </template>
                                            </v-radio>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content> 
                                        <v-row no-gutters>
                                                <v-col :cols="$vuetify.breakpoint.xs ? '12' : '6'" class="mt-2">
                                                     <v-col cols="12" class="pa-0">
                                                <small class="small-label" :class="{'text-error' : errors.first('amountTendered') }">{{paymentmethod}} Amount Tendered*</small>
                                                <hb-text-field
                                                box
                                                data-vv-name="total_amount"
                                                data-vv-as="Amount Tendered"
                                                v-model="total_amount"
                                                v-validate="'required|max:45'"  
                                                placeholder="0"
                                                :error="errors.has('total_amount')"
                                                @blur="$validator.validate('total_amount')"
                                                @input="handleAmountTendered('total_amount', $event)"
                                                condensed
                                                class="mt-2 cash-input-filed"
                                                
                                                >
                                                <template v-slot:prepend-inner>
                                                        <div>
                                                        $
                                                        </div>
                                                </template>
                                            </hb-text-field>
                                            </v-col>
                                            
                                            <v-col cols="12" class="pa-0">
                                                <v-text-field
                                                    key="ref_name"
                                                    :class="{'custom-field-error' : errors.first('ref_name')}"
                                                    hide-details
                                                    v-model= "ref_name"
                                                    data-vv-name="ref_name"
                                                    data-vv-as="Reference Name"
                                                    :error-messages="errors.collect('ref_name')"
                                                    label="Reference Name"
                                                    id="ref-name"
                                                    name="ref-name"
                                                    autocomplete="cc-ref-name"
                                                    ></v-text-field>
                                               </v-col>
                                               <v-col cols="12" class="pa-0">
                                            <v-textarea
                                                :class="{'custom-field-error' : errors.first('notes')}"
                                                rows="2"
                                                hide-details
                                                v-model="notes"
                                                data-vv-name="notes"
                                                :error-messages="errors.collect('notes')"
                                                label="Notes"
                                                id="notes"
                                                name="cnotes"
                                                autocomplete="ccnotes"
                                                @input="handleInputUpdate('payment', 'notes', $event)"
                                                >
                                                </v-textarea>
                                           </v-col>
                
                                                </v-col>
                                            </v-row>
         
                                       </v-expansion-panel-content>
                                      </v-expansion-panel>
                                      <v-expansion-panel>
                                        <v-expansion-panel-header expand-icon="">
                                            <v-radio value="direct_deposit">
                                                <template v-slot:label>
                                                    <div class="d-flex  align-center justify-space-between label-width">
                                                    <div class="d-flex align-center hb-font-body-medium">
                                                        Direct Deposit
                                                    </div>
                                                    <div><hb-icon class="mr-3" color="#101318">mdi-checkbook</hb-icon></div>
                                                    </div>
                                                </template>
                                            </v-radio>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content> 
                                        <v-row no-gutters>
                                                <v-col :cols="$vuetify.breakpoint.xs ? '12' : '6'" class="mt-2">
                                                     <v-col cols="12" class="pa-0">
                                                <small class="small-label" :class="{'text-error' : errors.first('amountTendered') }">{{paymentmethod}} Amount Tendered*</small>
                                                <hb-text-field
                                                box
                                                data-vv-name="total_amount"
                                                data-vv-as="Amount Tendered"
                                                v-model="total_amount"
                                                v-validate="'required|max:45'"  
                                                placeholder="0"
                                                :error="errors.has('total_amount')"
                                                @blur="$validator.validate('total_amount')"
                                                @input="handleAmountTendered('total_amount', $event)"
                                                condensed
                                                 class="mt-2 cash-input-filed"
                                                >
                                                <template v-slot:prepend-inner>
                                                        <div>
                                                        $
                                                        </div>
                                                </template>
                                            </hb-text-field>
                                            </v-col>
                                            
                                            <v-col cols="12" class="pa-0">
                                                <v-text-field
                                                    key="ref_name"
                                                    :class="{'custom-field-error' : errors.first('ref_name')}"
                                                    hide-details
                                                    v-model= "ref_name"
                                                    data-vv-name="ref_name"
                                                    data-vv-as="Reference Name"
                                                    :error-messages="errors.collect('ref_name')"
                                                    label="Reference Name"
                                                    id="ref-name"
                                                    name="ref-name"
                                                    autocomplete="cc-ref-name"
                                                    ></v-text-field>
                                               </v-col>
                                               <v-col cols="12" class="pa-0">
                                            <v-textarea
                                                :class="{'custom-field-error' : errors.first('notes')}"
                                                rows="2"
                                                hide-details
                                                v-model="notes"
                                                data-vv-name="notes"
                                                :error-messages="errors.collect('notes')"
                                                label="Notes"
                                                id="notes"
                                                name="cnotes"
                                                autocomplete="ccnotes"
                                                @input="handleInputUpdate('payment', 'notes', $event)"
                                                >
                                                </v-textarea>
                                           </v-col>
                
                                                </v-col>
                                            </v-row>
         
                                       </v-expansion-panel-content>
                                      </v-expansion-panel>
                                      <v-expansion-panel>
                                        <v-expansion-panel-header expand-icon="">
                                            <v-radio value="card">
                                                <template v-slot:label>
                                                    <div class="d-flex  align-center justify-space-between label-width">
                                                    <div class="d-flex align-center hb-font-body-medium">
                                                        Credit/Debit
                                                    </div>
                                                    <div><hb-icon class="mr-3" color="#101318">mdi-credit-card-outline</hb-icon></div>
                                                    </div>
                                                </template>
                                            </v-radio>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content> 
                                        <v-row no-gutters>
                                                <v-col :cols="$vuetify.breakpoint.xs ? '12' : '6'" class="mt-2">
                                                     <v-col cols="12" class="pa-0">
                                                <small class="small-label" :class="{'text-error' : errors.first('amountTendered') }">{{paymentmethod}} Amount Tendered*</small>
                                                <hb-text-field
                                                box
                                                data-vv-name="total_amount"
                                                data-vv-as="Amount Tendered"
                                                v-model="total_amount"
                                                v-validate="'required|max:45'"  
                                                placeholder="0"
                                                :error="errors.has('total_amount')"
                                                @blur="$validator.validate('total_amount')"
                                                @input="handleAmountTendered('total_amount', $event)"
                                                condensed
                                                 class="mt-2 cash-input-filed"
                                                >
                                                <template v-slot:prepend-inner>
                                                        <div>
                                                        $
                                                        </div>
                                                </template>
                                            </hb-text-field>
                                            </v-col>
                                            
                                            <v-col cols="12" class="pa-0">
                                                <v-text-field
                                                    key="ref_name"
                                                    :class="{'custom-field-error' : errors.first('ref_name')}"
                                                    hide-details
                                                    v-model= "ref_name"
                                                    data-vv-name="ref_name"
                                                    data-vv-as="Reference Name"
                                                    :error-messages="errors.collect('ref_name')"
                                                    label="Reference Name"
                                                    id="ref-name"
                                                    name="ref-name"
                                                    autocomplete="cc-ref-name"
                                                    ></v-text-field>
                                               </v-col>
                                               <v-col cols="12" class="pa-0">
                                            <v-textarea
                                                :class="{'custom-field-error' : errors.first('notes')}"
                                                rows="2"
                                                hide-details
                                                v-model="notes"
                                                data-vv-name="notes"
                                                :error-messages="errors.collect('notes')"
                                                label="Notes"
                                                id="notes"
                                                name="cnotes"
                                                autocomplete="ccnotes"
                                                @input="handleInputUpdate('payment', 'notes', $event)"
                                                >
                                                </v-textarea>
                                           </v-col>
                
                                                </v-col>
                                            </v-row>
         
                                       </v-expansion-panel-content>
                                      </v-expansion-panel>
                                      <v-expansion-panel>
                                        <v-expansion-panel-header expand-icon="">
                                            <v-radio value="direct_debit">
                                                <template v-slot:label>
                                                    <div class="d-flex  align-center justify-space-between label-width">
                                                    <div class="d-flex align-center hb-font-body-medium">
                                                        Direct Debit
                                                    </div>
                                                    <div><hb-icon class="mr-3" color="#101318">mdi-checkbook</hb-icon></div>
                                                    </div>
                                                </template>
                                            </v-radio>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content> 
                                        <v-row no-gutters>
                                                <v-col :cols="$vuetify.breakpoint.xs ? '12' : '6'" class="mt-2">
                                                     <v-col cols="12" class="pa-0">
                                                <small class="small-label" :class="{'text-error' : errors.first('amountTendered') }">{{paymentmethod}} Amount Tendered*</small>
                                                <hb-text-field
                                                box
                                                data-vv-name="total_amount"
                                                data-vv-as="Amount Tendered"
                                                v-model="total_amount"
                                                v-validate="'required|max:45'"  
                                                placeholder="0"
                                                :error="errors.has('total_amount')"
                                                @blur="$validator.validate('total_amount')"
                                                @input="handleAmountTendered('total_amount', $event)"
                                                condensed
                                                 class="mt-2 cash-input-filed"
                                                >
                                                <template v-slot:prepend-inner>
                                                        <div>
                                                        $
                                                        </div>
                                                </template>
                                            </hb-text-field>
                                            </v-col>
                                            
                                            <v-col cols="12" class="pa-0">
                                                <v-text-field
                                                    key="ref_name"
                                                    :class="{'custom-field-error' : errors.first('ref_name')}"
                                                    hide-details
                                                    v-model= "ref_name"
                                                    data-vv-name="ref_name"
                                                    data-vv-as="Reference Name"
                                                    :error-messages="errors.collect('ref_name')"
                                                    label="Reference Name"
                                                    id="ref-name"
                                                    name="ref-name"
                                                    autocomplete="cc-ref-name"
                                                    ></v-text-field>
                                               </v-col>
                                               <v-col cols="12" class="pa-0">
                                            <v-textarea
                                                :class="{'custom-field-error' : errors.first('notes')}"
                                                rows="2"
                                                hide-details
                                                v-model="notes"
                                                data-vv-name="notes"
                                                :error-messages="errors.collect('notes')"
                                                label="Notes"
                                                id="notes"
                                                name="cnotes"
                                                autocomplete="ccnotes"
                                                @input="handleInputUpdate('payment', 'notes', $event)"
                                                >
                                                </v-textarea>
                                           </v-col>
                
                                                </v-col>
                                            </v-row>
         
                                       </v-expansion-panel-content>
                                      </v-expansion-panel>
                                      <v-expansion-panel>
                                        <v-expansion-panel-header expand-icon="">
                                            <v-radio value="cash">
                                                <template v-slot:label>
                                                    <div class="d-flex  align-center justify-space-between label-width">
                                                    <div class="d-flex align-center hb-font-body-medium">
                                                        Cash
                                                    </div>
                                                    <div><hb-icon class="mr-3" color="#101318">mdi-cash-multiple</hb-icon></div>
                                                    </div>
                                                </template>
                                            </v-radio>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content> 
                                        <v-row no-gutters>
                                                <v-col :cols="$vuetify.breakpoint.xs ? '12' : '6'" class="mt-2">
                                                     <v-col cols="12" class="pa-0">
                                                <small class="small-label" :class="{'text-error' : errors.first('amountTendered') }">{{paymentmethod}} Amount Tendered*</small>
                                                <hb-text-field
                                                box
                                                data-vv-name="total_amount"
                                                data-vv-as="Amount Tendered"
                                                v-model="total_amount"
                                                v-validate="'required|max:45'"  
                                                placeholder="0"
                                                :error="errors.has('total_amount')"
                                                @blur="$validator.validate('total_amount')"
                                                @input="handleAmountTendered('total_amount', $event)"
                                                condensed
                                                 class="mt-2 cash-input-filed"
                                                >
                                                <template v-slot:prepend-inner>
                                                        <div>
                                                        $
                                                        </div>
                                                </template>
                                            </hb-text-field>
                                            </v-col>
                                            
                                            <v-col cols="12" class="pa-0">
                                                <v-text-field
                                                    key="ref_name"
                                                    :class="{'custom-field-error' : errors.first('ref_name')}"
                                                    hide-details
                                                    v-model= "ref_name"
                                                    data-vv-name="ref_name"
                                                    data-vv-as="Reference Name"
                                                    :error-messages="errors.collect('ref_name')"
                                                    label="Reference Name"
                                                    id="ref-name"
                                                    name="ref-name"
                                                    autocomplete="cc-ref-name"
                                                    ></v-text-field>
                                               </v-col>
                                               <v-col cols="12" class="pa-0">
                                            <v-textarea
                                                :class="{'custom-field-error' : errors.first('notes')}"
                                                rows="2"
                                                hide-details
                                                v-model="notes"
                                                data-vv-name="notes"
                                                :error-messages="errors.collect('notes')"
                                                label="Notes"
                                                id="notes"
                                                name="cnotes"
                                                autocomplete="ccnotes"
                                                @input="handleInputUpdate('payment', 'notes', $event)"
                                                >
                                                </v-textarea>
                                           </v-col>
                
                                                </v-col>
                                            </v-row>
         
                                       </v-expansion-panel-content>
                                      </v-expansion-panel>
                                      <v-expansion-panel>
                                        <v-expansion-panel-header expand-icon="">
                                            <v-radio value="check">
                                                <template v-slot:label>
                                                    <div class="d-flex  align-center justify-space-between label-width">
                                                    <div class="d-flex align-center hb-font-body-medium">
                                                        Check
                                                    </div>
                                                    <div><hb-icon class="mr-3" color="#101318">mdi-checkbook</hb-icon></div>
                                                    </div>
                                                </template>
                                            </v-radio>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content> 
                                        <v-row no-gutters>
                                                <v-col :cols="$vuetify.breakpoint.xs ? '12' : '6'" class="mt-2">
                                                     <v-col cols="12" class="pa-0">
                                                <small class="small-label" :class="{'text-error' : errors.first('amountTendered') }">{{paymentmethod}} Amount Tendered*</small>
                                                <hb-text-field
                                                box
                                                data-vv-name="total_amount"
                                                data-vv-as="Amount Tendered"
                                                v-model="total_amount"
                                                v-validate="'required|max:45'"  
                                                placeholder="0"
                                                :error="errors.has('total_amount')"
                                                @blur="$validator.validate('total_amount')"
                                                @input="handleAmountTendered('total_amount', $event)"
                                                condensed
                                                 class="mt-2 cash-input-filed"
                                                >
                                                <template v-slot:prepend-inner>
                                                        <div>
                                                        $
                                                        </div>
                                                </template>
                                            </hb-text-field>
                                            </v-col>
                                            
                                            <v-col cols="12" class="pa-0">
                                                <v-text-field
                                                    key="ref_name"
                                                    :class="{'custom-field-error' : errors.first('ref_name')}"
                                                    hide-details
                                                    v-model= "ref_name"
                                                    data-vv-name="ref_name"
                                                    data-vv-as="Reference Name"
                                                    :error-messages="errors.collect('ref_name')"
                                                    label="Reference Name"
                                                    id="ref-name"
                                                    name="ref-name"
                                                    autocomplete="cc-ref-name"
                                                    ></v-text-field>
                                               </v-col>
                                               <v-col cols="12" class="pa-0">
                                            <v-textarea
                                                :class="{'custom-field-error' : errors.first('notes')}"
                                                rows="2"
                                                hide-details
                                                v-model="notes"
                                                data-vv-name="notes"
                                                :error-messages="errors.collect('notes')"
                                                label="Notes"
                                                id="notes"
                                                name="cnotes"
                                                autocomplete="ccnotes"
                                                @input="handleInputUpdate('payment', 'notes', $event)"
                                                >
                                                </v-textarea>
                                           </v-col>
                
                                                </v-col>
                                            </v-row>
         
                                       </v-expansion-panel-content>
                                      </v-expansion-panel>
                                      <v-expansion-panel>
                                        <v-expansion-panel-header expand-icon="">
                                            <v-radio value="invoice">
                                                <template v-slot:label>
                                                    <div class="d-flex  align-center justify-space-between label-width">
                                                    <div class="d-flex align-center hb-font-body-medium">
                                                        Credit Balance
                                                    </div>
                                                    <div><hb-icon class="mr-3" color="#101318">mdi-checkbook</hb-icon></div>
                                                    </div>
                                                </template>
                                            </v-radio>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content> 
                                            <v-row no-gutters>
                                            <v-col class="pr-6 hb-font-header-3-medium mt-2">Credit Balance</v-col>
                                            <v-col class="hb-font-header-3-medium d-flex justify-end">{{creditBalance | formatMoney }}</v-col>
                                        </v-row>
                                        <div  class="pt-5 hb-font-body-medium"><span>Select Invoice to Apply Credit</span>
                                        </div> 
                                        <v-card elevation="0">
                                                <v-card-title class="d-flex align-center ma-0 pa-0 inv-header-cell">
                                                    <v-col cols="2" class="d-flex  hb-font-body-medium justify-start">
                                                        <span>Invoice</span>
                                                    </v-col>
                                                    <v-col cols="3" class="d-flex  hb-font-body-medium align-center justify-start">
                                                        <span>Credit Balance</span>
                                                    </v-col>
                                                    <v-col cols="3" class="d-flex hb-font-body-medium align-center justify-start">
                                                        <span>Balance Due</span>
                                                    </v-col>
                                                    <v-col cols="4" class="d-flex  hb-font-body-medium align-center justify-start">
                                                        <span>Amount Applied</span>
                                                    </v-col>
                                                </v-card-title>
                                                <v-divider></v-divider>
                                                <v-card-text v-for="(line, index) in invoices_payments"
                                                    class="pa-0 ma-0 hb-default-font-size" >
                                                    <v-row class="d-flex pa-0 mx-0">
                                                        <v-col cols="2" class="d-flex align-center hb-font-caption-medium justify-start">
                                                            <span>{{ line.invoice_number }}</span>
                                                        </v-col>

                                                        <v-col cols="3" class="d-flex align-center hb-font-caption-medium justify-start ">
                                                            <HbAutocomplete
                                                                v-model="invoices_payments[index].payment_id"
                                                                @change="setoverpayment(index)"
                                                                :items="payments"
                                                                item-text="name" 
                                                                item-value="id"
                                                                v-validate="'required|max:45'"
                                                                data-vv-scope="default"
                                                                data-vv-name="autocomplete-box"
                                                                data-vv-as="Autocomplete Box"
                                                                :error="errors.has('default.autocomplete-box')"
                                                                placeholder="Select"
                                                            />
                                                        </v-col>

                                                        <v-col cols="3" class="d-flex align-center hb-font-caption-medium justify-start ">
                                                            <span>{{ line.balance  | formatMoney }}</span>
                                                        </v-col>

                                                        <v-col cols="4" class="d-flex align-center hb-font-caption-medium justify-start">
                                                            <hb-text-field type='Number' condensed box medium v-model="invoices_payments[index].amount"
                                                                v-validate="'required|max:45'" placeholder="0">
                                                                <template v-slot:prepend-inner>
                                                                    $
                                                                </template>
                                                            </hb-text-field>
                                                        </v-col>

                                                    </v-row>
                                                    <v-divider></v-divider>

                                                </v-card-text>
                                                <v-container  v-if=" total_amount - totalamount > 0" fluid>
                                            </v-container>
                                        </v-card> 
                                       </v-expansion-panel-content>
                                      </v-expansion-panel>

                                    </v-expansion-panels>                                  
                                </v-radio-group>
                                
                                </v-col>

                            </v-row>
                        </v-container>
                </div>
            </div>
            <!-- <v-col cols="1">
            <v-divider vertical></v-divider>
           </v-col> -->

        </div>
        <hb-bottom-action-bar @close="CloseNationalAccount">
            <template v-slot:right-actions>
                <hb-btn color="primary" :disabled="processBtn"  @click="recordaPayment()"
                    >Record Payment</hb-btn>
                
            </template>
        </hb-bottom-action-bar>
    </div>
</template>
<script>
import api from "../../../../assets/api.js";
import { notificationMixin } from "@/mixins/notificationMixin.js";
import { mapGetters, mapMutations } from "vuex";
import { EventBus } from "../../../../EventBus.js";
import moment from 'moment';
export default {
    name: "Record_A_Payment",
    props: ['contact', 'unit_id', 'property_id'],
    mixins: [notificationMixin],
    data() {
        return {
            payment_type:"bank_transfer",
            pay:[],
            deleteLeaseLoading: false,
            gps_payload: {},
            close_confirm: false,
            panel: [0],
            invoices_payments:[],
            invoice: [],
            payments: [],
            edit:"",
            ref_name:"",
            notes: '',
            total_amount : "",
            creditBalance: ''
        };
    },
    components: {
    },
    created() {
        EventBus.$on('reset_lease_hb_model', this.openModel);
    },
    watch: {
        edit(){
            this.invoices_payments.forEach(invoices => {
                    invoices.amount = invoices.balance;
                });
            // this.total_amount = this.totalamount
               
               
        }

    },    async mounted() {
        await this.setAccountInfo()
    },
    computed: {
        ...mapGetters({
            properties: "propertiesStore/filtered",
            NationalAccount: 'onBoardingStore/getNationalAccount',
        }),
        processBtn(){
            if(this.total_amount>0){
                return false
            }else{
                return true
            }

        },
        calculateLength() {
            let leases = this.contact?.Leases.filter(lease => !lease.end_date)
            return leases?.filter((lease) => {
                return this.filterLeases(lease.Unit.property_id);
            })?.length;
        },
        totalamount(){
            return parseFloat(this.invoices_payments.reduce((sum, invoices_payments) => sum +  parseFloat(invoices_payments.amount) , 0)).toFixed(2) 
            
        },
        paymentmethod(){
            switch(this.payment_type){
                    case 'invoice':
                        return 'Credit Balance '
                        break;
                    case 'check':
                        return 'Check '
                        break;
                    case 'cash':
                        return 'Cash '
                        break;
                    case 'direct_debit':
                        return 'Direct Debit '
                        break;
                    case 'card':
                        return 'Credit/Debit '
                        break;
                    case 'direct_deposit':
                        return 'Direct Deposit '
                        break;
                    case 'bank_transfer':
                        return 'Bank Transfer '
                        break;
                    default:
                        return ' '
                }

        },
        computedBusinessAddress() {
            if (
                this.contact.Business &&
                this.contact.Business.Address
            ) {
                const address_1 = this.contact.Business.Address.address
                    ? this.contact.Business.Address.address
                    : "";
                const address_2 = this.contact.Business.Address.address2
                    ? this.contact.Business.Address.address2
                    : "";

                let address = address_1;
                if (address_2 != "") address += " " + address_2;

                address +=
                    ", " +
                    this.$options.filters.formatAddress(
                        this.contact.Business.Address
                    );

                return address;
            } else {
                return undefined;
            }
        },
    },
    destroyed() {
        EventBus.$off('reset_lease_hb_model', this.openModel);
    },
    methods: {
        openModel(payload = {}) {
            this.gps_payload = payload;
            if ('property_ids' in this.gps_payload && this.gps_payload.property_ids.length > 0) EventBus.$emit('reset_gps_bulk_property', this.gps_payload);
            else EventBus.$emit('reset_gps_property', this.gps_payload);
        },
        CloseNationalAccount() {
            if (this.showFinal) {
                this.close_confirm = true
            }
            else {
                this.$emit('close')
            }
        },
        filterLeases(property_id) {
            return this.properties.some((i) => i.id === property_id);
        },
        async recordaPayment(){
            let data;
            
            let payment={
                "method": this.payment_type,
                "amount": this.total_amount,
                "notes": this.notes,
                "ref_name": this.ref_name
            }

            if(this.payment_type == "invoice" && this.total_amount > parseFloat(this.invoices_payments.reduce((sum, invoices_payments) => sum +  parseFloat(invoices_payments.amount), 0)).toFixed(2)){
                this.showMessageNotification({ type: 'error', description: 'over payment is not allowed on credit balance and over payment' })
                return
            }

            if(this.payment_type == "invoice"){

                 data = {"invoices_payments":this.invoices_payments}
            }else{
                 data = {"payment":payment,"invoices_payments":this.invoices_payments}
            }
            
            try{
             let response = await api.post(this, api.NATIONAL_ACCOUNT + `${this.$route.query.na_id}/payment`, data)
                
            if(response){
                 this.showMessageNotification({
                            type: "success",
                            description: "Your transaction has been recorded successfully"
                        });
                        this.CloseNationalAccount()
            }
            }catch(err){ 
                this.showMessageNotification({
                            type: 'error',
                            description: err,
                        });
                    }


    },
    setoverpayment(index){
        const payment =  this.payments.find(payment => payment.id === this.invoices_payments[index].payment_id);
        if(this.invoices_payments[index].balance > payment.overpayment){
            this.invoices_payments[index].amount = payment ? payment.overpayment : null;
        }
        else{
            this.invoices_payments[index].amount =  this.invoices_payments[index].balance

        }
        this.total_amount =  parseFloat(this.invoices_payments.reduce((sum, invoices_payments) => sum +  parseFloat(invoices_payments.amount), 0)).toFixed(2)

    },

        async addPayment(invoices,index) {
            console.log("rtghurthguj",this.pay[index])
           if(this.pay[index] == true){

                this.invoices_payments.push({"invoice_id":invoices.id,"amount":invoices.balance,"balance":invoices.balance,"invoice_number":invoices.invoice_number})
                
            }else{
                
                this.invoices_payments = this.invoices_payments.filter(invoice => invoice.invoice_id !== invoices.id);

            }
            this.total_amount = parseFloat(this.invoices_payments.reduce((sum, invoices_payments) => sum +  parseFloat(invoices_payments.amount), 0)).toFixed(2)
        },
        setPayment(edit){
            if(!edit){
            }

        },

        async setAccountInfo() {
            let data;
            try {
                await api.get(this, api.NATIONAL_ACCOUNT + `${this.$route.query.na_id}/open-transactions`)
                    .then(async (res) => {
                        this.invoice = res.invoices;
                        this.payments = res.payments
                        this.payments.map(payment => payment.name = payment.payment_type == "payment"? "PMT " + '('+ moment(payment.date).format('MMM DD YYYY') +') - $' + payment.overpayment : "INV " + '('+ moment(payment.date).format('MMM DD YYYY') +') - $' + payment.overpayment)
                        this.creditBalance = this.payments.reduce((sum, payment) => sum + payment.overpayment, 0);
                        console.log(this.creditBalance);

                    });

                await api
                    .get(
                        this,
                        api.NATIONAL_ACCOUNT +
                        `${this.$route.query.na_id}?contact_id=${this.$route.params.contact_id}`
                    )
                    .then(async (res) => {
                        data = res[0];
                    });

            } catch (error) {
                console.log(error, "error");
            }
        },
    },
}
</script>
<style scoped>
.lead-intake-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    background-color: #f9fafb;
}

.lead-intake-top {
    flex-direction: row;
    align-items: stretch;
    flex-grow: 1;
    overflow: auto;
}

.movein-left {
    align-items: stretch;
    display: flex;
    flex-direction: column;
    flex: 5;
    overflow: hidden;
    height: 100%;
    box-shadow: 8px 0px 18px rgba(71, 84, 116, 0.2) !important;
    z-index: 202 !important;
}

.movein-right {
    flex: 4;
    display: flex;
    overflow: hidden;
}

.movein-right>>>.v-window {
    height: calc(100% - 20px) !important;
}

.add-padding-overlay-active {
    padding-bottom: 150px !important;
}

.tab-items {
    /* display: flex; */
    flex: 1;
    overflow: auto;
    height: 100%;
    padding-bottom: 5%;
    background-color: #f9fafb !important;
    /* width: -webkit-fill-available; */
}

.footer-wrapper {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #ffffff;
    padding: 12px 16px;
    box-shadow: inset 0px 1px 0px rgba(142, 142, 143, 0.15);
    width: 100%;
    border-top: 1px solid #dfe3e8;
    z-index: 1;
}

.theme--light.v-tabs-items {
    background-color: #f9fafb !important;
}

.lease-info-main {
    overflow: hidden !important;
}

.lease-total-overlay {
    position: absolute;
    bottom: 60px;
    width: -webkit-fill-available;
    width: -moz-available;
    padding: 0;
    z-index: 300;
    box-shadow: 0px -4px 10px 3px rgba(71, 84, 116, 0.1);

}

.lease-total-overlay>>>.v-card {
    border-radius: 0;
    padding: 0px !important;
}
.disabled-label {
  color: gray;         /* Adjust color as desired for a disabled effect */
  opacity: 0.5;        /* Makes it look faded */
}

.label-width {
  display: block;
  width: 100% !important;
 }

 .expansion-panel >>> .v-expansion-panel:not(:first-child):after {
   border: 0.5px solid rgba(0, 0, 0, 0.12);
 }
 .expansion-panel .v-expansion-panel::before{
   box-shadow : 0px 4px 10px 3px rgba(71, 84, 116, 0.1) !important;
   -webkit-box-shadow: none !important;
 }

 .expansion-panel >>> .v-expansion-panel-content__wrap{
   padding-left: 16px !important;
   padding-right: 16px !important;
   padding-top: 0px !important;
   padding-bottom: 4px !important;
 }
 .border-style{
  border-top: 0.1px solid black;
  border-bottom: 0.1px solid black;
 }

 .expansion-panel .v-expansion-panel-header.v-expansion-panel-header--active,
 .expansion-panel .v-expansion-panel-header.v-expansion-panel-header--active::before {
    background-color: #e0f5f5;  
 }

 .label-width {
  display: block;
  width: 100% !important;
 }

 ::v-deep.v-input--radio-group .v-messages {
  display: none;
 }
 ::v-deep.v-input--radio-group .v-input__slot { 
  margin-bottom: 0px !important;
 }
 .v-input--radio-group--column .v-radio:not(:last-child):not(:only-child){
  margin-bottom: 0px !important;
 }
 .expansion-panel .v-expansion-panel-content{
  background-color: #F9FAFB;
 }
.hb-text-field-width-370{
    max-width: 100% !important
}
.hb-text-field-condensed-wrapper{
    margin-right: 0px !important
}
.cash-input-filed  >>> fieldset legend{
    display: none !important;
}
</style>
